// extracted by mini-css-extract-plugin
export default {"renameModal":"styles_renameModal__jLlPO","inputLabel":"styles_inputLabel__tYSP1","header":"styles_header__IQycH","title":"styles_title__f7scb"};